// extracted by mini-css-extract-plugin
export default {"pageBody":"PageBody--pageBody--4wGDd","filled":"PageBody--filled--tox8a"};